// extracted by mini-css-extract-plugin
module.exports = {"Boxes":"Boxes_Boxes__Omabb"};